import styled from 'styled-components';
import { HouseInfoProps, LandInfoProprs, BasicInfoProps } from '../../data';
import ItemStateMap from './ItemStateMap';
import { useState, useEffect, useMemo } from 'react';
import BuildingInfo from './BuildingInfo';
import SummaryBuildingInfo from './SummaryBuildingInfo';
import LandInfo from './LandInfo';
import LandImg from './LandImg';
import LandUsePlan from './LandUsePlan';
import ItemAddress from './ItemAddress';
import ItemUseState from './ItemUseState';
import { useReportContext } from '../../../../context/DetailContext';
import { AFileList, PFileList } from '../../../../sidebar';
import { SButton2 } from '../../../../sidebar/SButton';
import LoanInfoService from '../../../../service/LoanInfo';
const attachmentIcon = '/assets/images/icon/Icon_Attachment.svg';
const category = {
  house: [
    '연면적',
    '건물층수',
    '건폐율',
    '용적률',
    '주용도',
    '건물구조',
    '노후년도',
  ],
  subHouseInfo: [
    '구분',
    '건물명',
    '주용도',
    '기타용도',
    '용적률산정연면적',
    '허가일',
    '주 건축물',
    '부속 건축물',
    '착공일',
    '총 호수/가구수/세대수',
    '외 필지수',
    '사용승인일',
    '위반내용',
  ],
  land: [
    '토지면적',
    '용도지역',
    '지목',
    '이용상황',
    '고저',
    '도로',
    '용적률',
    '건폐율',
  ],
};

interface itemStateProps {
  landInfo: LandInfoProprs;
  houseInfo: HouseInfoProps;
  landUsePlan: any;
  appraisalevaluation: string;
  locationInfo: string;
  subHouseInfo?: any;
  groupCategory: string;
  data?: any;
  caseInfo?: any;
  linkSet?: any;
  attachmentFile?: any[];
  setShowFileModal: React.Dispatch<React.SetStateAction<boolean>>;
  iidx?: string;
  basicInfo?: any;
  children?: React.ReactNode; 
}

const ItemState = ({
  landInfo,
  houseInfo,
  landUsePlan,
  appraisalevaluation,
  locationInfo,
  subHouseInfo,
  groupCategory,
  data,
  caseInfo,
  linkSet,
  attachmentFile,
  setShowFileModal,
  iidx,
  basicInfo,
  children,

}: itemStateProps) => {
  const [tab, setTab] = useState('land');
  const { type } = useReportContext();
  const [ready, setReady] = useState(false);
  const [deliveryButtonOn, setDeliveryButtonOn] = useState<boolean>(false);
  const [statusServeryButtonOn, setStatusServeryButtonOn] = useState<boolean>(false);
  const [targetItem, setTargetItem] = useState<any>(null);
// 1. linkSet, caseInfo가 준비되었는지 체크하는 용도
useEffect(() => {
  if (linkSet && caseInfo) {
    setReady(true);
  }
}, [linkSet, caseInfo]);

// 2. caseInfo.iidx가 바뀔 때 API 호출해서 버튼 상태 세팅
useEffect(() => {
  if (caseInfo?.iidx) {
    getStatusServeyData(caseInfo.iidx);
    getDeliveryData(caseInfo.iidx);
  }
}, [caseInfo?.iidx]);

// 3. API 호출 함수
const getStatusServeyData = async (iidx: number) => {
  try {
    const res = await LoanInfoService.statusServey(iidx);
    if (res.data && res.data.top) {
      setStatusServeryButtonOn(true);
    } else {
      setStatusServeryButtonOn(false);
    }
  } catch (e) {
    console.error(e);
    setStatusServeryButtonOn(false);
  }
};

const getDeliveryData = async (iidx: number) => {
  try {
    const res = await LoanInfoService.documentDelivery(iidx);
    if (res.data && res.data.date_list.length > 0 && res.data.date_list2.length > 0) {
      setDeliveryButtonOn(true);
    } else {
      setDeliveryButtonOn(false);
    }
  } catch (e) {
    console.error(e);
    setDeliveryButtonOn(false);
  }
};

// 4. 버튼 상태가 변하거나 조건이 충족될 때 AFileList 갱신
useEffect(() => {
  if (!linkSet?.buttonLink || !caseInfo?.iidx) return;

  const list = AFileList(linkSet, caseInfo, statusServeryButtonOn, deliveryButtonOn);
  setTargetItem(list.find(item => item.content === '현황조사서') || null);
}, [linkSet, caseInfo, statusServeryButtonOn, deliveryButtonOn]);


  // 유효한 값 존재 여부
  const hasNonNullValues = (data: Record<string, any>): boolean => {
    return Object.values(data).some((value) => {
      if (value === null || value === 'nodata') return false;
      if (Array.isArray(value) && value.length === 0) return false;
      if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) return false;
      if (typeof value === 'object' && value !== null) return hasNonNullValues(value);
      return true;
    });
  };

  // 중복 제거된 landUsePlan
  const cleanedLandUsePlan = useMemo(() => {
    const removeDuplicates = (array: any[]) => Array.from(new Set(array));

    const processObject = (obj: Record<string, any>): Record<string, any> => {
      const result: Record<string, any> = {};
      for (const [key, value] of Object.entries(obj)) {
        if (Array.isArray(value)) {
          result[key] = removeDuplicates(value);
        } else if (typeof value === 'object' && value !== null) {
          result[key] = processObject(value);
        } else {
          result[key] = value;
        }
      }
      return result;
    };

    return removeDuplicatesFromLandUsePlan(landUsePlan);

    function removeDuplicatesFromLandUsePlan(data: Record<string, any>) {
      return processObject(data);
    }
  }, [landUsePlan]);

  // 컨텐츠 렌더링 함수
  const renderContent = (tab: string) => {
    if (tab === 'building') {
      return (
        <>
          {houseInfo?.approvaldate === 'nodata' ? (
            <NoDataBox>등록된 건물정보가 없습니다.</NoDataBox>
          ) : (
            <BuildingInfo houseInfo={houseInfo} />
          )}
          {subHouseInfo && subHouseInfo.length > 0 && (
            <SummaryBuildingInfo data={subHouseInfo} />
          )}
        </>
      );
    } else {
      return (
        <>
          {landInfo && landInfo?.address !== 'nodata' && (
            <>
              <LandInfo landInfo={landInfo} />
              <LandImg landInfo={landInfo} />
              {landUsePlan && hasNonNullValues(landUsePlan) && (
                <LandUsePlan landUsePlan={cleanedLandUsePlan} linkSet={linkSet} />
              )}
            </>
          )}
        </>
      );
    }
  };
  
  return (
    <Container id="물건현황">
      <TitleBox>
        물건현황
     {type === 'a' && targetItem && targetItem.link &&(
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            cursor: 'pointer',
            
          }}
          onClick={() => {
            window.open(targetItem&&targetItem.link);
          }}
          >
            <img src={attachmentIcon} alt="" />
          {/* 아이콘은 따로 관리 필요 */}
          <SButton2
            content={targetItem&&targetItem.content}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '14px',
              fontWeight: '500',
              color: '#008AFF',
              padding: 0,
            }}
          />
        </div>
      )}
      </TitleBox>
      <ItemStateMap groupCategory={groupCategory} />
      {type === 'p' && (
        <>
          <ItemAddress data={locationInfo} />
          <ItemUseState appraisalevaluation={appraisalevaluation} />
        </>
      )}

      <TabButtonBox>
        <TabButton onClick={() => setTab('land')} isActive={tab === 'land'}>
          토지정보
        </TabButton>
        <TabButton
          onClick={() => setTab('building')}
          isActive={tab === 'building'}
        >
          건물정보
        </TabButton>
      </TabButtonBox>
      {renderContent(tab)}
    </Container>
  );
};

export default ItemState;

interface ButtonProps {
  isActive: boolean;
}

const TabButton = styled.div<ButtonProps>`
  width: 50%;
  padding: 8px;
  text-align: center;
  color: ${(props) => (props.isActive ? '#222222' : '#989BA2')};
  background-color: ${(props) => (props.isActive ? '#fff' : '')};
  box-shadow: ${(props) =>
    props.isActive ? '0px 0px 1px rgba(56, 58, 59, 0.08)' : 'none'};

  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`;

const TabButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 4px;
  background-color: rgba(112, 115, 124, 0.05);
  border-radius: 8px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 16px;
  background-color: #fff;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const NoDataBox = styled.div`
  width: 100%;
  height: 180px;
  background-color: #eff2f5;
  border-radius: 8px;
  color: rgba(55, 56, 60, 0.61);
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
`;

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const AttachButton = styled.div`
  
`